module.exports = __webpack_public_path__ + "img/multiplicar-white.f711fc57.png";